import { createActionCreator } from 'deox';
import { ServiceCategory } from '@/types';
import { ServiceCategoryForm } from '@/services/service-directory/service-category';

export const fetchServiceCategoriesActions = {
  request: createActionCreator('FETCH_SERVICE_CATEGORIES_REQUEST', (resolve) => (entityId?: string) =>
    resolve({ entityId })
  ),
  success: createActionCreator('FETCH_SERVICE_CATEGORIES_SUCCESS', (resolve) => (data: ServiceCategory[]) =>
    resolve({ data })
  ),
  failure: createActionCreator('FETCH_SERVICE_CATEGORIES_FAILURE', (resolve) => (error: Error) => resolve({ error })),
  reset: createActionCreator('FETCH_SERVICE_CATEGORIES_RESET'),
};

export const fetchServiceCategoryByIdActions = {
  request: createActionCreator('FETCH_SERVICE_CATEGORY_REQUEST', (resolve) => (id: string) => resolve({ id })),
  success: createActionCreator('FETCH_SERVICE_CATEGORY_SUCCESS', (resolve) => (serviceCategory: ServiceCategory) =>
    resolve(serviceCategory)
  ),
  failure: createActionCreator('FETCH_SERVICE_CATEGORY_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const createServiceCategoryActions = {
  request: createActionCreator('CREATE_SERVICE_CATEGORY_REQUEST', (resolve) => (serviceCategory: ServiceCategoryForm) =>
    resolve({ serviceCategory })
  ),
  success: createActionCreator('CREATE_SERVICE_CATEGORY_SUCCESS'),
  failure: createActionCreator('CREATE_SERVICE_CATEGORY_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const editServiceCategoryActions = {
  request: createActionCreator(
    'EDIT_SERVICE_CATEGORY_REQUEST',
    (resolve) => (id: string, serviceCategory: ServiceCategoryForm) => resolve({ id, serviceCategory })
  ),
  success: createActionCreator('EDIT_SERVICE_CATEGORY_SUCCESS'),
  failure: createActionCreator('EDIT_SERVICE_CATEGORY_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const deleteServiceCategoryActions = {
  request: createActionCreator('DELETE_SERVICE_CATEGORY_REQUEST', (resolve) => (id: string) => resolve({ id })),
  success: createActionCreator('DELETE_SERVICE_CATEGORY_SUCCESS'),
  failure: createActionCreator('DELETE_SERVICE_CATEGORY_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};
